import WindowAdapter from 'shared/window_adapter';

export default class CurrentWatchExcluder {
  constructor({ element: element }){
    this.element = element;
  }

  init(){
    this.update();
    this.bindOpenModal();
  }

  bindOpenModal() {
    let targetBtn = this.element.querySelector('a.js-menu-button');

    if(!targetBtn) { return; }

    targetBtn.addEventListener('click', () => {
      window.scroll(0, 44);
      document.querySelector('[data-capsule-id="tv_channels"]').click(); // delegate it to livestreaming capsule
    });
  }

  update(){
    let livestreamingId = this.getCurrentStreamId();
    let targetElement = this.element.querySelector(`[data-other-stream-id='${livestreamingId}']`);
    if (this.isOnlyStream(targetElement)){
      this.element.style.display = "none";
      return;
    }
    if(targetElement == null){
      return;
    }
    targetElement.style.display = "none";
  }

  getCurrentStreamId(){
    let pathname = WindowAdapter.locationPathname();
    let matches = pathname.match(/^\/live\/(\d+)/);
    if (matches == null)
      return null;
    return matches[1];
  }

  isOnlyStream(currentStream){
    if (currentStream){
      let streamElement = this.element.querySelectorAll('[data-other-stream-id]');
      return streamElement.length == 1;
    }
  }
}
